import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import { storeInstance } from './store';
import { sync } from 'vuex-router-sync';
import Vuelidate from 'vuelidate';
import infiniteScroll from 'vue-infinite-scroll';
import './styles/quasar.styl';
import 'quasar/dist/quasar.ie.polyfills';
import lang from 'quasar/lang/es.js';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import filters from './filters.js';
import {
  Quasar,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QCard,
  QCardSection,
  QCardActions,
  QDate,
  QInput,
  Ripple,
  QCheckbox,
  Notify,
  QChip,
  QExpansionItem,
  QSelect,
  QSeparator,
  ClosePopup,
  QBadge,
  QLinearProgress,
  Cookies,
  SessionStorage
} from 'quasar';

Vue.use(Quasar, {
  config: {},
  components: {
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCard,
    QCardSection,
    QCardActions,
    QDate,
    QInput,
    QCheckbox,
    QChip,
    QExpansionItem,
    QSelect,
    QSeparator,
    QBadge,
    QLinearProgress
  },
  directives: {
    ClosePopup,
    Ripple
  },
  plugins: {
    Cookies,
    Notify,
    SessionStorage
  },
  lang: lang
});

Vue.use(Vuelidate);
Vue.use(infiniteScroll);

Vue.config.productionTip = false; ;
filters.create(Vue);

const GlobalEventBus = new Vue();
Vue.prototype.$eventHub = GlobalEventBus;

sync(storeInstance, router);

Vue.config.productionTip = false;

new Vue({
  store: storeInstance,
  router,
  render: h => h(App)
}).$mount('#app');
